import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-soc-confirmation-dialog',
  templateUrl: './soc-confirmation-dialog.component.html',
  styleUrls: ['./soc-confirmation-dialog.component.scss']
})
export class SocConfirmationDialogComponent implements OnInit {

  public dialogTitle: string;
  public dialogText: string;

  constructor(
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig) {
      this.config.showHeader = false;
      if (this.config.data != undefined && this.config.data.title && this.config.data.text) {
        this.dialogTitle = this.config.data.title;
        this.dialogText = this.config.data.text;
      }
    }

  ngOnInit(): void {
  }

}
